import WorkContext from "@/components/commons/Work/WorkContext";
import ChartState from "@/components/commons/Work/ChartWork/ChartState";
import Dictionary from "@/types/Dictionary";

/** 
 * Classe de base d'une déclinaison de Context par type de Chart
 * @description A utiliser si nécessité d'avoir des propriétés propres au Chart
 */
export default class ChartContext extends WorkContext {
	/** Constructeur avec paramètres */
	public constructor(state: ChartState, results: any, configs: Dictionary<any>, variant: string, showConfigButtons: boolean = false) {
		super(state, results, configs, variant, showConfigButtons);
	}

	public ChangeContext(results: any, configs: Dictionary<any>){
		this.Results = results;
		this.Configs = configs;
	}
}